import { z } from "zod"

const ProblemDetailsSchema = z.object({
  type: z.string().optional(),
  title: z.string(),
  status: z.number().optional(),
  detail: z.string().optional(),
  instance: z.string().optional(),
})

export function hasJsonContent(response: Response) {
  const contentType = response.headers.get("content-type") || ""
  return (
    contentType.includes("application/json") ||
    contentType.includes("application/problem+json")
  )
}

export async function parseProblemDetails(response: Response) {
  if (!hasJsonContent(response)) {
    return null
  }

  const json = await response.json()

  const parseResult = ProblemDetailsSchema.safeParse(json)
  if (parseResult.success) {
    return parseResult.data
  }
  return null
}
